import { Icon } from 'summon-ui'
import { Box, Center, Paper, Text, Tooltip } from 'summon-ui/mantine'

interface TootipInfo {
  label: string
  w?: string | number
}
interface Props {
  info: string
  description: string
  tooltipInfo?: TootipInfo
}

const InfoCard = ({ info, description, tooltipInfo }: Props) => (
  <Paper withBorder className='!border-yellow-3 text-center' px='xs' py='lg' w='100%' radius='md'>
    <Text size='xl' fw='bold' c='yellow.6'>
      {info}
    </Text>
    <Center h='24px'>
      <Text size='xs' c='yellow.1' pl={tooltipInfo ? '6' : '0'}>
        {description}
      </Text>
      {tooltipInfo && (
        <Tooltip multiline withArrow label={tooltipInfo.label} w={tooltipInfo.w}>
          <Box>
            <Icon name='InfoCircle' c='yellow.1' />
          </Box>
        </Tooltip>
      )}
    </Center>
  </Paper>
)

export default InfoCard
